import React from "react";
import styles from "./FooterMenu.module.css";
import BtnFooterGroups from "./btnsFooter/BtnFooterGroups";
import BtnFooterRounds from "./btnsFooter/BtnFooterRounds";
import BtnFooterScoreTable from "./btnsFooter/BtnFooterScoreTable";
import { useHistory, useParams } from "react-router-dom";



function FooterMenu(props) {
  const { setActive } = props;

  const [activeGroup, setActiveGroup] = React.useState(
    setActive === "league" ? true : false
  );
  const [activeData, setActiveData] = React.useState(
    setActive === "scores" ? true : false
  );
  const [activeVs, setActiveVs] = React.useState(
    setActive === "vs" ? true : false
  );

  const history = useHistory();
  const { leagueId } = useParams();

  function changeButtons(setFuncTrue, setFuncFalse1, setFuncFalse2) {
    setFuncTrue(true);
    setFuncFalse1(false);
    setFuncFalse2(false);
  }

  function setButtons(btn) {
    if (btn === "league") {
      changeButtons(setActiveGroup, setActiveData, setActiveVs);
      const url = `/leagues/${leagueId}`;
      history.push(url);
    }
    if (btn === "scores") {
      changeButtons(setActiveData, setActiveGroup, setActiveVs);
      history.push(`/leagues/${leagueId}/scoreboard`);
    }
    if (btn === "vs") {
      changeButtons(setActiveVs, setActiveGroup, setActiveData);
      const url = `/leagues/${leagueId}/rounds/0`;
      history.push(url);
    }
  }

  function handleClick(e) {
    const activeBtn = e.currentTarget.id;
    setButtons(activeBtn);
  }

  return (
    <div className={styles.footerMenu}>
      <h3 id="league" onClick={handleClick}>
        <BtnFooterGroups isActive={activeGroup} />
      </h3>
      <h3 id="scores" onClick={handleClick}>
        <BtnFooterScoreTable isActive={activeData} />
      </h3>
      <h3 id="vs" onClick={handleClick}>
        <BtnFooterRounds isActive={activeVs} />
      </h3>
    </div>
  );
}



export default FooterMenu;
